module.exports = __webpack_public_path__ + "static/media/santa.8cf84dea.svg";